module.exports = __webpack_public_path__ + "img/section-bg-discount.aa0275e2.png";